import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { ViewScreenshot } from '../../../components/Feedback/ViewScreenshot'
import { FinalizarChamado } from './FinalizarChamado'
import { Description } from './Description'

export function Tabela({ data, setPriorityColor }) {
  return (
    <TableContainer>
      <Table variant="simple" size="sm" colorScheme="blue" overflow="hidden">
        <Thead>
          <Tr bg="blue.500">
            <Th color="gray.50">Nome</Th>
            <Th color="gray.50">Data de abertura</Th>
            <Th color="gray.50">Tipo de chamado</Th>
            <Th color="gray.50">Prioridade</Th>
            <Th color="gray.50">Descrição</Th>
            <Th color="gray.50">Imagem</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.map((item) => (
            <Tr key={item.numero_chamado}>
              <Td>{item.solicitante}</Td>
              <Td>
                {format(new Date(item.data_abertura), 'dd/MM/yyyy HH:mm', {
                  locale: ptBR,
                })}
              </Td>
              <Td>{item.tipo_chamado}</Td>
              <Td color={setPriorityColor(item.prioridade)}>
                {item.prioridade}
              </Td>
              <Td>
                <Description
                  item={item}
                  description={item?.detalhes_problema
                    ?.substring(0, 15)
                    .concat('...')}
                  completeDescription={item?.detalhes_problema}
                />
              </Td>
              <Td>
                <ViewScreenshot screenshot={item.link_imagem} />
              </Td>
              <Td>
                <FinalizarChamado item={item} />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
